<template>
    <v-card>
        <v-card-title class="text-h5">Receive Items</v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-form v-model="valid" class="mb-2 mx-1 mt-3">
                <v-data-table
                    id="virtual-scroll-table"
                    disable-pagination
                    hide-default-footer
                    :headers="filterHeaders"
                    :items="filteredItems"
                    class="elevation-0"
                    :mobile-breakpoint="0"
                    fixed-header
                    :style="{ width: '100%' }"
                    :height="$vuetify.breakpoint.mdAndDown ? '70vh' : '35vh'"
                    item-key="index"
                    :loading="loading"
                >
                    <template v-slot:top>
                        <v-row
                            no-gutter
                            class="mt-0 mx-0 pt-4 pb-0 pb-4 align-center"
                            :style="{ 'background-color': '#eeeeee' }"
                        >
                            <v-col cols="9">
                                <h2 class="ml-4">PENDING DELIVERIES</h2>
                                <v-spacer />
                            </v-col>
                        </v-row>
                    </template>
                    <!--HEADERS-->
                    <template v-slot:[`header.selected`]="{ header }">
                        <div class="d-flex align-center justify-center">
                            <p class="ma-0 pr-2">{{ header.text }}</p>
                            <v-simple-checkbox
                                color="primary"
                                v-model="selectAll"
                                class="d-flex align-center justify-center"
                                @click="selectAllItems"
                            ></v-simple-checkbox>
                        </div>
                    </template>
                    <template v-slot:[`header.partNumber`]="{ header }">
                        <v-text-field
                            class="py-2 mt-2 custom-label"
                            :label="header.text"
                            v-model="partNumberToFilter"
                            dense
                        />
                    </template>
                    <template v-slot:[`header.originProcess`]="{ header }">
                        <v-text-field
                            class="py-2 mt-2 custom-label"
                            :label="header.text"
                            v-model="originProcessToFilter"
                            dense
                        />
                    </template>
                    <template v-slot:[`header.destinationProcess`]="{ header }">
                        <v-text-field
                            class="py-2 mt-2 custom-label"
                            :label="header.text"
                            v-model="destinationProcessToFilter"
                            dense
                        />
                    </template>
                    <!--ITEMS-->
                    <template v-slot:[`item.originProcess`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0 text-capitalize">
                                {{ item.prevProcess.name }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.destinationProcess`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0 text-capitalize">
                                {{ item.nextProcess.name }}
                            </p>
                        </div>
                    </template>

                    <template v-slot:[`item.deliveredBy`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0 text-capitalize">
                                {{ getUserName(item.deliveredBy) }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.deliveredOn`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0 text-capitalize">
                                {{
                                    formatDate(
                                        item.deliveredOn._seconds ||
                                            item.deliveredOn.seconds
                                    )
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.qtyToReceive`]="{ item }">
                        <div class="d-flex justify-center">
                            <v-text-field
                                type="number"
                                class="my-0"
                                v-model="item.qtyToReceive"
                                :rules="[
                                    () =>
                                        rules.maxValue(item.qtyToReceive, item),
                                ]"
                            >
                            </v-text-field>
                        </div>
                    </template>
                    <template v-slot:[`item.locationItem`]="{ item }">
                        <div
                            class="d-flex justify-center"
                            v-if="
                                item.nextProcess &&
                                    (item.nextProcess.id ===
                                        packingProcess.id ||
                                        item.nextProcess.id ==
                                            readyForPackingProcess.id)
                            "
                        >
                            <v-text-field
                                type="text"
                                class="my-0"
                                v-model="item.locationItem"
                                :rules="[() => validateLocation(item)]"
                            >
                            </v-text-field>
                        </div>
                        <div class="d-flex justify-center" v-else>
                            <p type="text" class="my-0">
                                N\A
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.selected`]="{ item }">
                        <div class="d-flex justify-center">
                            <v-simple-checkbox
                                color="primary"
                                v-model="item.selected"
                                @click="verifySelected"
                            ></v-simple-checkbox>
                        </div>
                    </template>
                </v-data-table>

                <div class="d-flex align-center mb-2 mt-4">
                    <v-icon>
                        mdi-account-arrow-left
                    </v-icon>
                    <h3 class="ml-2">Receiving Operator</h3>
                </div>

                <v-row no-gutters>
                    <v-col cols="12" xl="6" lg="6" md="6">
                        <v-text-field
                            v-model="code"
                            type="password"
                            hide-details
                            label="User Code"
                            :rules="[rules.required]"
                            required
                            class="pl-1 pr-4 pt-1"
                        />
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                        <v-text-field
                            v-model="confirmCode"
                            type="password"
                            hide-details
                            label="Confirm Code"
                            :rules="[rules.required, matchCode]"
                            required
                            class="pl-1 pt-1"
                        />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
            <v-btn text color="secondary" @click="close">
                Close
            </v-btn>
            <v-spacer></v-spacer>
            <!-- Show Exceptions Button -->
            <v-btn
                v-if="
                    workOrder.deliveriesException &&
                        workOrder.deliveriesException.length > 0
                "
                text
                color="error"
                @click="showExceptions = true"
                class="mr-2"
            >
                <v-icon left>mdi-alert-circle</v-icon>
                View Exceptions ({{ workOrder.deliveriesException.length }})
            </v-btn>

            <!-- Batch Progress Indicator -->
            <div
                v-if="batchProgress.isProcessing"
                class="d-flex align-center mr-4"
            >
                <span class="text-caption">
                    Processing batch {{ batchProgress.current }} of
                    {{ batchProgress.total }}
                </span>
            </div>

            <v-btn
                color="primary"
                :disabled="buttonConditions()"
                @click="receive"
                :loading="loading"
            >
                save
            </v-btn>
        </v-card-actions>

        <!-- Exceptions Dialog -->
        <v-dialog v-model="showExceptions" max-width="1200px">
            <AssemblyPartnumbersExeption
                :items="workOrder.deliveriesException || []"
                @closeDialog="showExceptions = false"
            />
        </v-dialog>
    </v-card>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'
import _ from 'lodash'
import cryptoJs from 'crypto-js'
import moment from 'moment'
import AssemblyPartnumbersExeption from './AssemblyPartnumbersExeption.vue'

export default {
    name: 'ReceiveITems',
    components: {
        AssemblyPartnumbersExeption,
    },
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        valid: false,
        loading: false,
        confirmCode: undefined,
        code: undefined,
        showExceptions: false,
        batchSize: 100, // Number of items to process per batch
        batchProgress: {
            current: 0,
            total: 0,
            isProcessing: false,
        },
        rules: {
            required: v => !!v || 'The value is required',
            maxValue: (v, item) => {
                let min = 0
                let max = 0
                if (item.qty > 0) {
                    max = item.qty
                } else {
                    min = item.qty
                }
                if (Number(v || 0) > max) {
                    return `The value cannot be greater than ${max}.`
                } else if (Number(v || 0) < min) {
                    return `The value cannot be less than ${min}.`
                } else {
                    return true
                }
            },
        },
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
        readyForPackingProcess: {
            id: 'readyForPacking',
            name: 'readyForPacking',
        },
        headers: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'ORIGIN PROCESS',
                value: 'originProcess',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESTINATION PROCESS',
                value: 'destinationProcess',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QTY DELIVERED',
                value: 'qty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QTY TO RECEIVE',
                value: 'qtyToReceive',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DELIVERED BY',
                value: 'deliveredBy',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DELIVERED ON',
                value: 'deliveredOn',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SELECTED',
                value: 'selected',
                align: 'center',
                sortable: false,
            },
        ],
        partNumberToFilter: null,
        deliveries: [],
        selectAll: false,
        users: [],
        originProcessToFilter: null,
        destinationProcessToFilter: null,
        settingProcessesId: '',
    }),
    computed: {
        filterHeaders() {
            let headers = _.cloneDeep(this.headers)
            if (
                this.filteredItems.some(
                    item =>
                        item.nextProcess &&
                        (item.nextProcess.id === this.packingProcess.id ||
                            item.nextProcess.id ==
                                this.readyForPackingProcess.id)
                )
            ) {
                headers.splice(7, 0, {
                    text: 'LOCATION',
                    value: 'locationItem',
                    align: 'center',
                    sortable: false,
                })
            }
            return headers
        },
        filteredItems() {
            let conditions = []

            if (this.partNumberToFilter) {
                conditions.push(this.filterForPartNumber)
            }

            if (this.originProcessToFilter) {
                conditions.push(this.filterByOriginProcess)
            }

            if (this.destinationProcessToFilter) {
                conditions.push(this.filterByDestinationProcess)
            }

            conditions.push(this.filterByPending)

            if (conditions.length > 0) {
                return this.deliveries.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }

            return this.deliveries
        },
    },

    async mounted() {
        try {
            this.loading = true
            const {
                data: { settings },
            } = await API.getSettings()
            const settingProcesses = settings.find(
                setting => setting.name.toLowerCase() == 'processes'
            )
            if (settingProcesses) {
                this.settingProcessesId = settingProcesses.id
            }
            const {
                data: { users },
            } = await API.getLiteUsers()
            this.users = users
            this.deliveries = []
            let count = 0
            this.projectWorkOrders = await API.getWorkOrdersByProject({
                projectId: this.workOrder.projectId,
                includeClosed: false,
            })
            this.workOrder.items.forEach(item => {
                if (item.deliveries) {
                    const assemblyStock = {
                        id: 'assemblyStock',
                        code: 'Stock',
                    }
                    item.deliveries.forEach(delivery => {
                        delivery.partNumber = item.partNumber
                        delivery.id = item.id
                        delivery.qtyToReceive = delivery.qty
                        delivery.index = count
                        delivery.partNumberId = item.partNumberId
                        delivery.lastProcess = item.processes
                            ? item.processes[item.processes.length - 1]
                            : null
                        // use stock as default destination work order
                        if (
                            delivery.lastProcess &&
                            delivery.nextProcess.id == delivery.lastProcess &&
                            delivery.nextProcess.assemblyProcess
                        ) {
                            delivery.destinationWorkOrder = assemblyStock
                        } else {
                            delete delivery.destinationWorkOrder
                        }
                        count++
                    })
                    this.deliveries.push(...item.deliveries)
                }
            })
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('closeDialog')
        },
        matchCode() {
            return !!(
                this.code &&
                this.confirmCode &&
                this.code === this.confirmCode
            )
        },
        selectAllItems() {
            const items = this.filteredItems.map(i => i.id)
            this.deliveries.forEach(i => {
                if (items.includes(i.id)) {
                    i.selected = this.selectAll
                }
            })
            this.deliveries = _.cloneDeep(this.deliveries)
        },
        filterForPartNumber(item) {
            return (
                item.partNumber &&
                item.partNumber
                    .toLowerCase()
                    .includes(this.partNumberToFilter.toLowerCase())
            )
        },
        filterByPending(item) {
            return !item.receivedBy
        },
        filterByDestinationProcess(item) {
            return (
                item.nextProcess.name &&
                item.nextProcess.name
                    .toLowerCase()
                    .includes(this.destinationProcessToFilter.toLowerCase())
            )
        },
        filterByOriginProcess(item) {
            return (
                item.prevProcess.name &&
                item.prevProcess.name
                    .toLowerCase()
                    .includes(this.originProcessToFilter.toLowerCase())
            )
        },
        getUserName(userId) {
            const user = this.users.find(u => u.id == userId)
            let name = ''
            if (user) {
                name = user.name
            }
            return name
        },
        formatDate(seconds) {
            return `${moment.unix(seconds).format('YYYY-MM-DD HH:mm')}`
        },
        verifySelected() {
            if (this.filteredItems.length > 0) {
                this.selectAll = !this.filteredItems.find(
                    i => i.selected != true
                )
            } else {
                this.selectAll = false
            }
        },

        async receive() {
            try {
                this.loading = true
                const encryptedCode = cryptoJs.AES.encrypt(
                    this.code,
                    process.env.VUE_APP_ENCRYPTION_PHRASE
                ).toString()
                this.code = encryptedCode

                // Get all selected items with only required keys
                const selectedItems = this.filteredItems
                    .filter(i => i.selected)
                    .map(item => {
                        // Create new item with only the required keys
                        const newItem = {
                            qtyToReceive: item.qtyToReceive,
                            partNumberId: item.partNumberId,
                            nextProcess: item.nextProcess,
                            locationItem: item.locationItem,
                            prevProcess: item.prevProcess,
                            deliveryId: item.deliveryId,
                            qty: item.qty,
                            deliveredBy: item.deliveredBy,
                            deliveredOn: item.deliveredOn,
                            destinationWorkOrder: item.destinationWorkOrder,
                        }

                        // Handle destinationWorkOrder conversion if it's an object
                        if (
                            newItem.destinationWorkOrder &&
                            typeof newItem.destinationWorkOrder === 'object'
                        ) {
                            newItem.destinationWorkOrder =
                                newItem.destinationWorkOrder.id
                        } else if (!newItem.destinationWorkOrder) {
                            delete newItem.destinationWorkOrder
                        }

                        return newItem
                    })

                // Process items in batches
                const allProcessedItems = []
                const totalBatches = Math.ceil(
                    selectedItems.length / this.batchSize
                )

                // Initialize batch progress
                this.batchProgress = {
                    current: 0,
                    total: totalBatches,
                    isProcessing: true,
                }

                for (let i = 0; i < selectedItems.length; i += this.batchSize) {
                    const batch = selectedItems.slice(i, i + this.batchSize)
                    const currentBatchNumber =
                        Math.floor(i / this.batchSize) + 1

                    // Update progress
                    this.batchProgress.current = currentBatchNumber

                    try {
                        const batchParams = {
                            items: batch,
                            receivingSignCode: this.code,
                            workOrderId: this.workOrder.id,
                            settingId: this.settingProcessesId,
                        }

                        const batchResult = await API.receiveItems(batchParams)

                        // Handle different response formats
                        if (Array.isArray(batchResult)) {
                            allProcessedItems.push(...batchResult)
                        } else if (
                            batchResult &&
                            typeof batchResult === 'object'
                        ) {
                            // If it's an object, check if it has a data property or items property
                            if (
                                batchResult.data &&
                                Array.isArray(batchResult.data)
                            ) {
                                allProcessedItems.push(...batchResult.data)
                            } else if (
                                batchResult.items &&
                                Array.isArray(batchResult.items)
                            ) {
                                allProcessedItems.push(...batchResult.items)
                            } else {
                                // If it's just a single object, push it directly
                                allProcessedItems.push(batchResult)
                            }
                        } else {
                            // If it's not an array or object, just push it as is
                            allProcessedItems.push(batchResult)
                        }

                        // Optional: Add a small delay between batches to prevent overwhelming the server
                        if (i + this.batchSize < selectedItems.length) {
                            await new Promise(resolve =>
                                setTimeout(resolve, 100)
                            )
                        }
                    } catch (error) {
                        this.setErrorItems({
                            source: this.$options.name,
                            message: error.message,
                        })
                    }
                }

                // Reset batch progress
                this.batchProgress.isProcessing = false
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.$emit('closeDialog')
            }
        },
        buttonConditions() {
            return (
                !this.valid ||
                this.filteredItems.filter(i => i.selected).length == 0
            )
        },
        validateLocation(item) {
            if (item.nextProcess.id === 'packing' && item.selected) {
                return !!item.locationItem || 'The value is required'
            }
            return true
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
.v-data-table {
    border: 1px solid #eeeeee;
}
</style>
